module.exports = __webpack_public_path__ + "assets/img/Dave-Nosworthy.ecb3bb9b.jpg";